// extracted by mini-css-extract-plugin
module.exports = {"XLink":"XLink_XLink__V13_r"};